import React from "react";

import "./BackDrop.css";

const BackDrop = (props: any) => <div className="backdrop"></div>;

export default BackDrop;
